module.exports = __webpack_public_path__ + "img/AL803-1-EN.47c2d401.jpg";